import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBandage,
  faBaseball,
  faBolt,
  faBone,
  faBottleBaby,
  faBowlFood,
  faBrain,
  faBroomWide,
  faBug,
  faBugs,
  faCapsules,
  faCat,
  faClock,
  faCloud,
  faCookieBite,
  faDna,
  faDog,
  faDogLeashed,
  faDroplet,
  faDumbbell,
  faEar,
  faEye,
  faFlowerTulip,
  faGauge,
  faHandSparkles,
  faHandsHoldingHeart,
  faHeart,
  faHeartPulse,
  faHorse,
  faHouseHeart,
  faKidneys,
  faKitMedical,
  faLeafHeart,
  faLungs,
  faMicroscope,
  faMoon,
  faMortarPestle,
  faMosquito,
  faPaw,
  faPills,
  faPrescriptionBottleMedical,
  faPumpSoap,
  faScissors,
  faSeedling,
  faShieldPlus,
  faShieldVirus,
  faSpa,
  faStethoscope,
  faStomach,
  faSyringe,
  faTag,
  faTooth,
  faTriangleExclamation,
  faUtensils,
  faVial,
  faWeightScale,
  faWheat,
  faWind,
  faWorm,
} from "@fortawesome/pro-thin-svg-icons";

// Maps a category slug to its fa-thin glyph; color is applied separately by cycle
// position. Unlisted slugs fall back to DEFAULT_CATEGORY_ICON.
const CATEGORY_ICONS: Readonly<Record<string, IconDefinition>> = {
  "Dog-toys": faBaseball,
  "Medical-Supplies": faKitMedical,
  "Pet Nutrition": faBowlFood,
  "adverse-food-reaction": faTriangleExclamation,
  "allergy-reduction": faWind,
  "allergy-relief": faFlowerTulip,
  antibiotics: faPrescriptionBottleMedical,
  "anxiety-behavior": faBrain,
  "appetite-stimulation": faUtensils,
  "arthritis-pain": faBone,
  "behavioral-health": faBrain,
  "bone-joint-support": faBone,
  "calming-care": faCloud,
  "cardiac-support": faHandsHoldingHeart,
  "cardiovascular-health": faHandsHoldingHeart,
  "cleaning-waste-supplies": faBroomWide,
  "coat-health": faHandSparkles,
  "cognitive-health": faBrain,
  "collars-leashes": faDogLeashed,
  compounds: faMortarPestle,
  dental: faTooth,
  "dental-health": faTooth,
  "dental-health-diet": faTooth,
  deals: faTag,
  dermatology: faHandSparkles,
  dewormers: faWorm,
  "diabetes-mellitus": faGauge,
  diagnostics: faMicroscope,
  "diets-nutrition": faBowlFood,
  "digestive-health": faStomach,
  "dog-treats": faCookieBite,
  "ear-care": faEar,
  "endocrine-system-health": faDna,
  "equine-antibiotics": faPrescriptionBottleMedical,
  "equine-antiprotozoals": faBug,
  "equine-bone-joint-support": faBone,
  "equine-corticosteroids": faPills,
  "equine-dermatologic-hoof-care": faHorse,
  "equine-digestive-support": faStomach,
  "equine-estrus-suppression": faDna,
  "equine-fly-&-pest-control": faMosquito,
  "equine-hyaluronate-therapy": faSyringe,
  "equine-immune-modulators": faShieldVirus,
  "equine-internal-health-support": faStethoscope,
  "equine-liver-support": faLeafHeart,
  "equine-musculoskeletal-support": faBone,
  "equine-nsaids": faPills,
  "equine-nutritional-support": faWheat,
  "equine-oral-dewormers": faWorm,
  "equine-parasite-control": faMosquito,
  "equine-probiotics": faStomach,
  "equine-respiratory-support": faLungs,
  "equine-sedation": faMoon,
  "equine-skin-barrier-protection": faHorse,
  "equine-therapeutics": faSpa,
  "equine-thyroid-support": faDna,
  "equine-ulcer-medication": faStomach,
  "equine-wound-treatment": faBandage,
  "eye-care": faEye,
  "eye-ear-oral-care": faEye,
  eye_health: faEye,
  "flea-tick": faBugs,
  gastrointestinal: faStomach,
  "general-equine-care": faHorse,
  "general-health": faHeart,
  "gestation/lactation": faBottleBaby,
  "glucose-management": faGauge,
  "grooming-supplies": faScissors,
  growth: faSeedling,
  "hairball-reduction": faCat,
  "healthy-aging": faClock,
  "heart-blood-pressure": faHandsHoldingHeart,
  heartworm: faHeartPulse,
  "hematuria-detection": faVial,
  "hepatic-support": faLeafHeart,
  "high-energy": faBolt,
  home_wellness: faHouseHeart,
  "immune-support": faShieldVirus,
  "immune-system-health": faShieldVirus,
  "joint-health": faBone,
  "litter-boxes": faCat,
  "liver-health": faLeafHeart,
  "lower-urinary-tract-support": faDroplet,
  medication: faPrescriptionBottleMedical,
  multivitamins: faCapsules,
  "muscular-health": faDumbbell,
  "other-medication": faPills,
  "pet-essentials": faPaw,
  "pill-assistance": faPills,
  preventative: faShieldPlus,
  recovery: faBandage,
  recovery_collars: faDog,
  "renal-support": faKidneys,
  respiratory: faLungs,
  sedation: faMoon,
  "seizure-epilepsy": faBrain,
  "sensitive-digestion": faStomach,
  shampoos: faPumpSoap,
  "skin-and-coat-health": faHandSparkles,
  "skin-coat": faHandSparkles,
  "skin-support": faHandSparkles,
  "stress-anxiety": faBrain,
  "supplemental-health": faCapsules,
  supplements: faCapsules,
  "syringes-needles": faSyringe,
  "thyroid-care": faDna,
  "thyroid-hormone": faDna,
  treats: faCookieBite,
  "urinary-care": faDroplet,
  "urinary-health": faDroplet,
  "urinary-kidney": faKidneys,
  "weight-loss": faWeightScale,
  "weight-maintenance": faWeightScale,
};

const DEFAULT_CATEGORY_ICON = faPaw;

export const iconForCategorySlug = (slug: string): IconDefinition =>
  CATEGORY_ICONS[slug] ?? DEFAULT_CATEGORY_ICON;
